import client from './client'
import type { PaginatedResponse } from '@/types/common'
import type { Notification } from '@/types/notifications'

export function list(params?: Record<string, unknown>) {
  return client.get<PaginatedResponse<Notification>>('/notifications', { params })
}

export function getUnreadCount() {
  return client.get<{ unread_count: number }>('/notifications/unread_count')
}

export function markRead(id: string) {
  return client.patch(`/notifications/${id}/read`)
}

export function markAllRead() {
  return client.post('/notifications/read_all')
}
